/**
 * À qui écrire, sur les pages « Confidentialité » et « Mentions légales » (chantier comptes,
 * ticket 05). L'adresse est posée par Igor (`npm run comptes -- contact`) et lue par
 * `GET /api/contact` ; tant qu'il n'y en a pas, une phrase de repli, jamais une adresse inventée.
 * Testé dans tests/client/comptes/pagesPubliques.test.ts.
 */

export const COMMENT_JOINDRE_SANS_CONTACT =
  'Demande à la personne qui t’a donné le code d’invitation : elle sait qui tient Nextilt.';

export function commentJoindre(contact: string | null | undefined): { adresse: string | null; phrase: string } {
  const adresse = contact?.trim() ? contact.trim() : null;
  return adresse === null
    ? { adresse: null, phrase: COMMENT_JOINDRE_SANS_CONTACT }
    : { adresse, phrase: 'Écris à cette adresse :' };
}
